import React, { useCallback, useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import Input from '../common2/Input';
import Button from '../common/Button';
import container from '../../container';
import PlainButton from '../common/PlainButton';
import BackIcon from '../../icons/arrow-left.svg';
import Link from '../common/Link';

import styles from './SSOLoginForm.scss';
import ErrorContainer from './ErrorContainer';

type ApiError = {
  response?: {
    status: number;
  };
  message?: string;
};

type GetSSORedirectLinkResponse = {
  redirectUrl: string;
};

function SSOLoginForm() {
  const [namespace, setNamespace] = useState('');

  const handleNamespaceInput = (value: string) => {
    setNamespace(value);
  };

  const { isLoading, isError, mutate, error } = useMutation<GetSSORedirectLinkResponse, ApiError, void>({
    mutationKey: ['getSSORedirectLink', namespace],
    mutationFn: async () => container.touchpointsApi.getSSORedirectLink(namespace),
    onSuccess: (data) => {
      window.location.href = data.redirectUrl;
    },
  });

  const onSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    mutate();
  }, []);

  const getErrorMessage = () => {
    if (error?.response?.status === 400) {
      return 'The namespace provided was not found. Please check and try again.';
    }

    return 'A server error occurred. Please try again later.';
  };

  return (
    <form onSubmit={onSubmit} className={styles.ssoForm}>
      {isError && <ErrorContainer text={getErrorMessage()} />}
      <div className={styles.inputContainer}>
        <Input
          label="Namespace"
          placeholder="Enter your organization namespace"
          value={namespace}
          onChange={handleNamespaceInput}
          name="namespace"
          type="text"
          disabled={isLoading}
          large
        />
      </div>
      <div className={styles.buttonContainer}>
        <Button disabled={!namespace} isLoading={isLoading} primary type="submit">
          Continue
        </Button>
        <Link to={'/login'}>
          <PlainButton icon={BackIcon}>Back</PlainButton>
        </Link>
      </div>
    </form>
  );
}

export default SSOLoginForm;
